import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, Paragraph } from '@treams/treams-ui';

export default function Signature(props: {
	name: string;
	item: graphql.EvaluationSignatureItem;
	readonly?: boolean;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [field] = useField<boolean>(props.name + '.signature');
	const value = field.value ?? false;

	return (
		<>
			<Box maxWidth={600}>
				<Paragraph>{localize(props.item.title ?? []).text}</Paragraph>
			</Box>
			{value ? null : (
				<Flex mt={3}>
					<Button title={t('evaluation.submission.confirm.button')} />
				</Flex>
			)}
		</>
	);
}
